import { BrowserRouter, Routes, Route } from 'react-router-dom';
import StartPage from './StartPage';
import ForkPage from './ForkPage';
import ItemPage from './ItemPage';
import VideoPage from './VideoPage';
import WalletPage from './WalletPage';
import WalletPage1 from './WalletPage1';

const App = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<StartPage />} />
      <Route path="/fork" element={<ForkPage />} />
      <Route path="/item/:id" element={<ItemPage />} />
      <Route path="/video" element={<VideoPage />} />
      <Route path="/wallet" element={<WalletPage />} />
      <Route path="/wallet1" element={<WalletPage1 />} />
    </Routes>
  </BrowserRouter>
);

export default App;